<template xmlns="http://www.w3.org/1999/html">
  <div class="body">
    <div>
      <div class="editTitle">基本信息</div>
      <table class="table" cellpadding="0" cellspacing="0">
        <tr>
          <td class="tableLabel">对账类型:</td>
          <td class="tableModel">{{reconcileOrderVO.billType === 10 ? "整单对账" : "拆单对账"}}</td>
          <td class="tableLabel">对账单号：</td>
          <td class="tableModel">{{reconcileOrderVO.billNo}}</td>
          <td class="tableLabel">对账日期：</td>
          <td class="tableModel">{{reconcileOrderVO.createTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">供应商编号：</td>
          <td class="tableModel">{{reconcileOrderVO.supplierNo}}</td>
          <td class="tableLabel">供应商名称：</td>
          <td class="tableModel">{{reconcileOrderVO.supplierName}}</td>
          <td class="tableLabel">公司：</td>
          <td class="tableModel">S100电气</td>
        </tr>
        <tr>
          <td class="tableLabel">货币：</td>
          <td class="tableModel">CNY 中国人民币(CNY)</td>
          <td class="tableLabel">税率：</td>
          <td class="tableModel">{{reconcileOrderVO.taxNumber}}</td>
          <td class="tableLabel">采购组：</td>
          <td class="tableModel">{{reconcileOrderVO.buyUserName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">创建人：</td>
          <td class="tableModel">{{reconcileOrderVO.creatorName}}</td>
          <td class="tableLabel">备注:</td>
          <td class="tableModel" colspan="3">{{reconcileOrderVO.note}}</td>
        </tr>
      </table>
      <div style="background: #fff1f0;color: red;border: 1px solid #ff0000;font-size: 12px;font-weight: bold;padding-left: 5px">
        <p>注意：</p>
        <p>1：开票金额以调整差异金额为准！！</p>
        <p>2：财务开具发票时，余额必须为0！！</p>
        <p>3：差额可以不为0。如果差额过大，请关注行项差异大的金额！！</p>
        <p>4：如果申请开票后修改了采购订单金额，请及时退回对账单重新选择采购单对账！！</p>
        <p>5：只有采购订单行项全部入库后才可以申请对账！！</p>
        <p>6：明细不含税金额=sum(调整差异金额)； 结算不含税金额=sum(计算不含税金额)； 差额=结算不含税金额-明细不含税金额； 余额=实际开票不含税金额-明细不含税金额</p>
      </div>
      <div class="editTitle">金额信息</div>
      <table class="table1" cellpadding="0" cellspacing="0">
        <tr>
          <td class="tableLabel1">明细不含税金额</td>
          <td class="tableModel1">{{taxNotIncluded.toFixed(2)}}</td>
          <!--          <td class="tableLabel2">明细税额</td>-->
          <!--          <td class="tableModel1">{{taxSum.toFixed(2)}}</td>-->
          <!--          <td class="tableLabel1">明细含税</td>-->
          <!--          <td class="tableModel1">{{(taxNotIncluded+taxSum).toFixed(2)}}</td>-->
          <td class="tableLabel3">结算不含税金额</td>
          <td class="tableModel1">{{taxNotIncludedJS.toFixed(2)}}</td>
          <td class="tableLabel3">差额</td>
          <td class="tableModel1" colspan="3">{{(taxNotIncludedJS.toFixed(2)-taxNotIncluded.toFixed(2)).toFixed(2)}}</td>
        </tr>
        <tr>
          <td class="tableLabel1">实际开票不含税金额</td>
          <td class="tableModel1">{{reconcileOrderVO.invoice.netAmount ? parseFloat(reconcileOrderVO.invoice.netAmount).toFixed(2) : ""}}</td>
          <td class="tableLabel2">实际开票税额</td>
          <td class="tableModel1">{{reconcileOrderVO.invoice.taxAmount ? parseFloat(reconcileOrderVO.invoice.taxAmount).toFixed(2) : ""}}</td>
          <td class="tableLabel1">实际开票含税金额</td>
          <td class="tableModel1">{{reconcileOrderVO.invoice.amount ? parseFloat(reconcileOrderVO.invoice.amount).toFixed(2) : ""}}</td>
          <td class="tableLabel3">余额</td>
          <td class="tableModel1">{{reconcileOrderVO.invoice.netAmount ? (parseFloat(reconcileOrderVO.invoice.netAmount).toFixed(2)-taxNotIncluded.toFixed(2)).toFixed(2) : ""}}</td>
        </tr>
        <tr>
          <td class="tableLabel2">发票日期</td>
          <td class="tableModel1">
            {{reconcileOrderVO.invoice.invoiceDate ? reconcileOrderVO.invoice.invoiceDate.slice(0,10) : ""}}
          </td>
          <td class="tableLabel1">发票号码</td>
          <td class="tableModel1" colspan="7">{{reconcileOrderVO.invoice.invoiceNo}}</td>
        </tr>
        <tr>
          <td class="tableLabel2">发票凭证的凭证号码</td>
          <td class="tableModel1">{{reconcileOrderVO.invoice.FBELNR}}</td>
          <td class="tableLabel1">发票凭证年度</td>
          <td class="tableModel1">{{reconcileOrderVO.invoice.GJAHR}}</td>
          <td class="tableLabel1">财务凭证</td>
          <td class="tableModel1" colspan="3">{{reconcileOrderVO.invoice.KBELNR}}</td>
        </tr>
        <tr>
          <td class="tableLabel2">OCR识别状态</td>
          <td class="tableModel1">
            <el-tag :type="reconcileOrderVO.invoice.ocrStatus ? 'success' : 'danger'" size="small">{{reconcileOrderVO.invoice.ocrStatus ? '已识别' : '未识别'}}</el-tag>
          </td>
          <td class="tableLabel1">发票查验状态</td>
          <td class="tableModel1">
            <el-tag :type="reconcileOrderVO.invoice.checkStatus ? 'success' : 'danger'" size="small">{{reconcileOrderVO.invoice.checkStatus ? '已查验' : '未查验'}}</el-tag>
          </td>
          <td class="tableLabel1">发票占用状态</td>
          <td class="tableModel1">
            <el-tag :type="reconcileOrderVO.invoice.takeUpStatus ? 'success' : 'danger'" size="small">{{reconcileOrderVO.invoice.takeUpStatus ? '已占用' : '未占用'}}</el-tag>
          </td>
          <td class="tableLabel2">发票上传状态</td>
          <td class="tableModel1">
            <el-tag :type="reconcileOrderVO.invoice.uploadStatus ? 'success' : 'danger'" size="small">{{reconcileOrderVO.invoice.uploadStatus ? '已上传' : '未上传'}}</el-tag>
          </td>
        </tr>
      </table>
      <div class="editTitle" style="display: flex;flex-direction: row;align-items: center">
        <div>对账明细</div>
        <div style="margin-left: 20px">
          <el-checkbox v-model="priceFlags" @change="priceFlagType"/>
          <span style="font-size: 13px; font-weight: 600; margin-left: 3px">暂估</span>
        </div>
        <div>
          <el-button style="font-size: 13px; margin-left: 5px" type="primary" @click="downloadDetail(reconcileOrderVO)">明细下载</el-button>
        </div>
        <div class="historyBtn" style="color: #2d8cf0; font-size: 12px; margin-left: 1%; cursor: pointer" @click="changeOptionalPriceVOS()">
          {{isShow ? "隐藏" : "展开"}}
          <el-button style="padding: 1px 2px" :icon="isShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"/>
        </div>
      </div>
      <el-table
          v-if="isShow"
          stripe
          border
          class="reconcileTable"
          :data="priceFlagTypeList"
          height="60vh">
        <el-table-column label="采购单信息" align="center">
          <el-table-column prop="poCreateTime" align="center" width="85" label="下单日期">
            <template slot-scope="scope">
              <span>{{scope.row.poCreateTime ? scope.row.poCreateTime.slice(0, 10) : ""}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="priceFlag" align="center" width="70" label="价格类型"/>
          <el-table-column prop="partNo" width="85" align="center" label="物料编号"/>
          <el-table-column prop="partNameSpec" min-width="160" show-overflow-tooltip label="物料名称"/>
          <el-table-column width="130" align="center" label="采购订单/行号">
            <template slot-scope="scope">
              <div>{{scope.row.evaluate + "/" + scope.row.poDetailRowNo}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="poQuantity" align="center" width="95" label="采购订单数量"/>
          <el-table-column prop="poStockedQuantity" align="center" width="85" label="已收数量"/>
          <el-table-column prop="poQuantity" align="center" width="85" label="未收数量">
            <template slot-scope="scope">
              <span>{{scope.row.poStockedQuantity ? (scope.row.poQuantity - scope.row.poStockedQuantity) : ""}}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="送货单信息" align="center">
          <el-table-column width="130" align="center" label="送货单号/行号">
            <template slot-scope="scope">
              <div>{{scope.row.asnNo + "/" + scope.row.asnRowIndex}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="sumQuantity" align="center" width="90" label="送货单数量"/>
          <el-table-column prop="instockQuantity" align="center" width="80" label="入库数量"/>
        </el-table-column>
        <el-table-column label="对账单信息" align="center">
          <el-table-column prop="quantity" align="center" width="100" label="本次对账数量"/>
          <el-table-column prop="netPrice" align="center" width="100" label="不含税单价">
            <template slot-scope="scope">
              <span>{{scope.row.netPrice.toFixed(6)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" label="结算含税单价">
            <template slot-scope="scope">
              <span>{{(scope.row.netPrice * (parseInt(reconcileOrderVO.taxNumber.split('%'))/100+1)).toFixed(6)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="finalPrice" width="140" label="调整差异金额(不含税)">
            <template slot-scope="scope">
              <span v-show="parseFloat(scope.row.finalPrice) !== parseFloat((scope.row.quantity * scope.row.netPrice).toFixed(6))" style="color:red">*</span>
              <span>{{scope.row.finalPrice.toFixed(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="110" label="结算不含税金额">
            <template slot-scope="scope">
              <span>{{(scope.row.quantity * scope.row.netPrice).toFixed(6)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" label="结算含税金额">
            <template slot-scope="scope">
              <span>{{(scope.row.quantity * (scope.row.netPrice *(parseInt(reconcileOrderVO.taxNumber.split('%'))/100+1))).toFixed(6)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unit" align="center" width="80" label="单位"/>
          <el-table-column prop="note" align="center" width="140" label="备注"/>
        </el-table-column>
      </el-table>
      <div class="editTitle" style="margin-top:2%">
        订单附件
      </div>
<!--      <el-upload-->
<!--          action=""-->
<!--          :http-request="fileUpload"-->
<!--          :file-list="reconcileOrderVO.fileList"-->
<!--          :show-file-list="false"-->
<!--          style="float: left; margin-right: 5px">-->
<!--        <el-button :v-loading="uploadLoading" type="primary" style="margin-bottom: 5px"> 添加附件</el-button>-->
<!--      </el-upload>-->
      <el-table border :data="reconcileOrderVO.fileList">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="accessoryName" align="left" label="附件描述" show-overflow-tooltip/>
        <el-table-column label="下载" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" @click="download(scope.row)">下载</el-button>
            <el-button
                type="danger"
                style="margin-left:5px"
                @click="deleteFile(scope.row,scope.$index)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="editTitle" style="margin-top:2%">
        XML文件
      </div>
      <el-table border :data="reconcileOrderVO.xmlFileList" style="margin-bottom:2%">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="XML文件" show-overflow-tooltip/>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" @click="downloadXml(scope.row)">下载</el-button>
            <el-button
                type="danger"
                style="margin-left:5px"
                @click="deleteXmlFile(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="editTitle" style="margin-top:2%">
        供应商合同
      </div>
      <el-table border :data="reconcileOrderVO.contractList">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column
            prop="contractNo"
            align="center"
            label="合同编号"
            show-overflow-tooltip
            width="400"/>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";
  export default {
    components: {HandleDetail},
    data() {
      return {
        uploadLoading: false,
        billId: "0",
        billType: "0",
        sequId:"",
        priceFlags:false,
        isShow:true,
        priceFlagTypeList:[],
        reconcileOrderVO: {
          details:[],
          invoice:[],
          contractList:[],
        },
      };
    },
    computed: {
      // 明细含税金额
      // priceTwoAndThree() {
      //   let sum = 0;
      //   this.reconcileOrderVO.details.forEach((item) => {
      //     sum += (item.finalPrice * 1.13).toFixed(6);
      //   });
      //   return sum;
      // },
      //明细税额
      taxSum() {
        let sum = 0;
        this.reconcileOrderVO.details.forEach((item) => {
          sum += parseFloat((item.finalPrice*0.13).toFixed(2));
        });
        return sum;
      },
      //明细不含税
      taxNotIncluded() {
        let sum = 0;
        this.reconcileOrderVO.details.forEach((item) => {
          sum += parseFloat(item.finalPrice);
        });
        return sum;
      },
      //结算不含税金额
      taxNotIncludedJS() {
        let sum = 0;
        this.reconcileOrderVO.details.forEach((item) => {
          sum += parseFloat((item.quantity * item.netPrice).toFixed(2));
        });
        return sum;
      },
    },

    created() {
      this.billId = this.$route.query.billId + "";
      this.billType = this.$route.query.billType + "";
      this.sequId = this.$route.query.sequId + "";
      this.getData();
    },
    methods: {
      getData() {
        this.$http
          .get("basic", `soas/${this.billId}`)
          .then(resp => {
            console.log(resp);
            this.reconcileOrderVO = resp.data;
            this.priceFlagTypeList = resp.data.details;
          });
        
      },
      priceFlagType() {
        if (this.priceFlags) {
          this.priceFlagTypeList = this.priceFlagTypeList.filter((item) => item.priceFlag !== "信息");
        } else {
          this.getData();
        }
      },
      //附件下载
      download(row) {
        let data = {
          name:row.accessoryName,
          uuid:row.filePath,
        };
        this.$http.exportFile("basic","file/download",data).then(res => {
          console.log(res);
          let blob = new Blob([res.data],{type:"application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },
      changeOptionalPriceVOS() {
        this.isShow = !this.isShow;
      },
      //明细下载
      downloadDetail(reconcileOrderVO) {
        this.exportLoading = true;
        this.$http
          .exportFile("basic",`soas/exportMaterial/${reconcileOrderVO.pkId}`)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      deleteFile(row, index) {
        this.$http.get("basic", `soas/deleteInvoice/${this.reconcileOrderVO.pkId}`).then();
        this.reconcileOrderVO.fileList.splice(index, 1);
      },

      //XML文件下载
      downloadXml(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      //XML文件删除
      deleteXmlFile(row) {
        this.$confirm("是否确认删除该XML文件？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.$http.get("basic", `soas/deleteXmlFile/${row.accessoryID}`)
            .then((res) => {
              if (res.success) {
                this.$message.success("删除成功");
              }
            })
            .catch(() => {
              this.$message.error("删除失败");
            })
            .finally(() => {
              this.$http
                .get("basic", `soas/${this.reconcileOrderVO.pkId}`)
                .then(resp => {
                  this.reconcileOrderVO = resp.data;
                });
            });
        }).catch(() => {});
      },

      //附件上传
      fileUpload(params) {
        console.log(params);
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        var pkid = {
          pkid: this.reconcileOrderVO.pkId,
        };
        this.$http.postForFile("basic", `soas/uploadFile/${this.reconcileOrderVO.pkId}`, formData)
            .then((res) => {
              if (res.success) {
                console.log("123123123123123");
                this.uploadLoading = false;
                this.$message.success("上传成功");
              }
            })
            .catch(() => {
              this.uploadLoading = false;
              this.$message.error("上传失败");
            }).finally(() => {
          this.$http
              .get("basic", `soas/${this.reconcileOrderVO.pkId}`)
              .then(resp => {
                this.reconcileOrderVO = resp.data;
              });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .body {
    font-size: 14px;
    .table {
      width: 100%;
      border-top: 1px solid #bbb;
      border-left: 1px solid #bbb;
      margin: 2% auto;
      margin-top:0;
      .tableLabel {
        width: 130px;
        padding: 5px;
        text-align: left;
        background: #f4f7fa;
        border-bottom: 1px solid #bbb;
      }

      .tableModel {
        width: 20%;
        padding: 5px;
        border-left: 1px solid #bbb;
        border-right: 1px solid #bbb;
        border-bottom: 1px solid #bbb;
      }
    }
    .table1 {
      width: 100%;
      margin: 2% auto;
      margin-top:0;
      border-top: 1px solid #bbb;
      border-left: 1px solid #bbb;

      .tableLabel1 {
        width: 12%;
        padding: 5px;
        text-align: left;
        background: #f4f7fa;
        border-bottom: 1px solid #bbb;
      }

      .tableLabel2 {
        width: 10%;
        padding: 5px;
        text-align: left;
        background: #f4f7fa;
        border-bottom: 1px solid #bbb;
      }

      .tableLabel3 {
        width: 6%;
        padding: 5px;
        text-align: left;
        background: #f4f7fa;
        border-bottom: 1px solid #bbb;
      }

      .tableModel1 {
        width: 10%;
        padding: 5px;
        border-left: 1px solid #bbb;
        border-right: 1px solid #bbb;
        border-bottom: 1px solid #bbb;
      }
    }
    .editTitle {
      font-size:14px;
      color: #000;
      font-weight:700;
      padding: 2px;
      border-bottom:1px solid #333;
      margin-bottom: 1%;
    }
  }

  ::v-deep .reconcileTable .el-table__cell  {
    border: 1px solid #bbb;
    border-left:none;
    border-top:none;
  }
  .reconcileTable{
    border-top: 1px solid #bbb;
  }
  
</style>
